import { useMemo }            from 'react';
import { contentInfoType }    from 'types'
//import selectContent          from 'functions/actions/select_content_content';
import Tooltip                from '@mui/material/Tooltip';
import { words }              from 'utils/dictionary'
import { colors }             from 'utils/colors'
import { makeStyles }         from 'makeStyles';

const useStyles = makeStyles()(() => ({
  root: {
    width:           '100%',
    height:          60,
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    backgroundColor: '#FFF',
  },
  button: {
    height:          57,
    flex:            1,
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    backgroundColor: '#FFF',
    cursor:          'pointer',
    fontWeight:      'bold',
    fontSize:        18,
    borderTop:       `1px solid #CCC`,
  },
  innerText: {
     width:           '100%',
     height:          '100%',
     display:         'flex',
     alignItems:      'center',
     justifyContent:  'center',
     textAlign:       'center',
  }
}))

type IntroButtonProps = {
  lang:                  string;
  backgroundColor:       string;
  hover:                 string;
  manualVal:             string;
  val:                   contentInfoType;
  showDescriptionButton: boolean;
  disabled:              boolean;
  disabledGrade:         boolean;
  setHover:              (val: string) => void;
}

const IntroButton: React.FC<IntroButtonProps> = ({
  lang,
  backgroundColor,
  val,
  manualVal,
  hover,
  showDescriptionButton,
  disabled,
  disabledGrade,
  setHover,
}) => {

  const { classes } = useStyles();

  const [markDescription, buttonText, teacherContent] = useMemo(() => {

    const tc   = (val.origin === 'teacherLessons' || val.origin === 'mivdakim');
    const tag   = `${  val.app ? val.app : '' }${ val.uid ? `${ val.uid }` : val.lesson_id }`
    const bText = !val.origin ? '' : ( val.origin === 'teacherLessons' || val.origin === 'mivdakim' ) ? words['description'][lang] : words['viewVideo'][lang]

    return[
      manualVal === `${ tag }###description`,
      bText,
      tc
    ]
  },[val, manualVal, lang])


  return (
    <div className = { classes.root }>
        {
          showDescriptionButton
          &&
          <div
          dir = 'rtl'
            className    = { classes.button }
            onMouseEnter = { () => setHover('description') }
            onMouseLeave = { () => setHover( hover === 'description' ? '' : hover ) }
            onClick      = { () => { 
                import("functions/actions/select_content").then(func => {
                  func.selectContent(val, 'apps/grid/Buttons', `${ disabledGrade ? 'getGrade' : disabled ? 'getPlus' : 'appIntro' }`)
                }); 
              }
            }
            style        = {{
              backgroundColor: hover === 'description' ? backgroundColor : '#FFF',
              color:           hover === 'description' ? '#FFF' : '#445',
              fontWeight:      hover === 'description' ? 'bold' : undefined,
            }}
          >
            {
              teacherContent &&
              <Tooltip 
                 title           = { `${ !!val.description ? val.description : '' }` } 
                 placement       = "bottom"
                 componentsProps = {{ 
                   tooltip: { 
                     dir: 'rtl',
                     sx: { 
                       fontSize:   16,
                       textAlign: 'right'
                     }, 
                   } 
                }}
              >
                 <div
                    className = { classes.innerText }
                    style = {{
                      border:  markDescription ? `3px solid ${ colors.blue }` : undefined
                    }}
                  >
                    { buttonText }
                </div>
              </Tooltip> 
            }
            {
              !teacherContent &&
              <div
                className = { classes.innerText }
                style = {{
                  border:  markDescription ? `3px solid ${ colors.blue }` : undefined
                }}
              >
                  { buttonText }
                  
              </div>
             
            
            }
          </div>
        }
    </div>
  );
}


export default IntroButton;



